import React from "react";
import Input from "../Input";
import { FormattedMessage } from "react-intl";

export default (props) => {
  return (
    <Input
      {...props}
      type="url"
      validations={{ ...props.validations, isUrl: true }}
      validationErrors={{
        ...props.validationErrors,
        isUrl: (
          <FormattedMessage
            id="components.atoms.Form.Input.Url.invalidUrl"
            defaultMessage="This field must be a url address (e.g. https://www.example.com)"
          />
        ),
      }}
    />
  );
};
